import React from 'react';
import ReportForm from '../ReportForm/ReportForm';

/** Reworks a report that is still a draft, waiting, or was rejected. */
const EditReport = () => <ReportForm mode="edit" />;

export default EditReport;
